/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summarysourcefacebook2Inputs */

const en_summarysourcefacebook2 = /** @type {(inputs: Summarysourcefacebook2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook`)
};

const de_summarysourcefacebook2 = /** @type {(inputs: Summarysourcefacebook2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook`)
};

/**
* | output |
* | --- |
* | "Facebook" |
*
* @param {Summarysourcefacebook2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summarysourcefacebook2 = /** @type {((inputs?: Summarysourcefacebook2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summarysourcefacebook2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summarysourcefacebook2(inputs)
	return de_summarysourcefacebook2(inputs)
});
export { summarysourcefacebook2 as "summarySourceFacebook" }